import { render, staticRenderFns } from "./DropdownFormBox.vue?vue&type=template&id=cbf50c32"
import script from "./DropdownFormBox.vue?vue&type=script&lang=js"
export * from "./DropdownFormBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports